module.exports = __webpack_public_path__ + "static/media/ArrowLeftIcon.0488a0c3.svg";